<div class="checkout__page mb-5">
    <div class="row">
        <div class="col-md-1 my-4">
            <button id="checkout-back-button" type="button" class="button ghost__button icon__left p-0 chk-back-button"
                (click)="goBack()">
                <em class="fa fa-arrow-left"></em>
                Back
            </button>
        </div>
        <div class="col-md-7 header-formatting">
          <div class="title">Checkout</div>

          <small class="color--gray--2" *ngIf="!isPromoApplied || (isPromoApplied && payableAmount > 0)">Your information will never be published and will stay secure</small>

          <form class="form-class" #checkoutForm="ngForm" novalidate="novalidate" autocomplete="off" ngxStripeCardGroup
                [elementsOptions]="elementsOptions">
            <div class="row mt-4" *ngIf="!isPromoApplied || (isPromoApplied && payableAmount > 0)">
              <div class="col-md-12">

                <div class="row">
                  <div class="col-md-12 font-weight-bold mb-3">
                    <span>Card Information</span>
                    <span class="font-size-14 color--blue"> - REQUIRED</span>
                  </div>

                  <div class="col-lg-10 col-md-12">

                    <div class="row">
                      <div class="col-lg-8 col-md-10 col-12">
                        <div class="form-group">
                          <small class="m-0 text-muted">Card holder name</small>
                          <input type="text" placeholder="Name on Card" class="input input__blue"
                                 #CARD_NAME="ngModel" maxlength="30" [(ngModel)]="checkoutDetails.CARD_NAME"
                                 name="CARD_NAME" id="CARD_NAME" required
                                 pattern="^(?!.*([A-Za-z])\1{2})([a-zA-Z]{2,}\s[a-zA-Z]{1,}'?-?[a-zA-Z]{1,}\s?([a-zA-Z]{1,})?)"
                                 [ngClass]="{'input__error': (CARD_NAME.errors && (CARD_NAME.dirty || CARD_NAME.touched))}">
                          <small *ngIf="CARD_NAME.errors && (CARD_NAME.dirty || CARD_NAME.touched)"
                                 class="text-danger">Please enter valid name</small>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6 col-md-8 col-12">
                        <div class="form-group">
                          <small class="m-0 text-muted">Card number</small>
                          <ngx-stripe-card-number [options]="cardOptions" containerClass="input"
                                                  (change)="onChangeCardDetals($event)">
                          </ngx-stripe-card-number>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-4 col-md-5 col-8">
                        <div class="form-group">
                          <small class="m-0 text-muted">Expiration date</small>
                          <ngx-stripe-card-expiry [options]="cardOptions" containerClass="input"
                                                  (change)="onChangeCardDetals($event)">
                          </ngx-stripe-card-expiry>
                        </div>
                      </div>

                      <div class="col-lg-2 col-md-3 col-4">
                        <div class="form-group">
                          <small class="m-0 text-muted">CVV</small>
                          <ngx-stripe-card-cvc [options]="cardOptions" containerClass="input"
                                               (change)="onChangeCardDetals($event)">
                          </ngx-stripe-card-cvc>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

                <div class="row">
                  <div class="col-lg-7 col-md-12">
                    <div class="row">
                      <div class="col-lg-8 col-md-12 font-weight-bold mt-5 mb-3">
                        <span>Billing Address</span>
                        <span class="font-size-14 color--blue"> - REQUIRED</span>
                      </div>

                      <div class="col-md-12 font-weight-bold">
                        <label class="checkbox large">
                          <input class="checkbox__input" type='checkbox' [(ngModel)]="checkoutDetails.SAME_ADDRESS"
                                 #SAME_ADDRESS="ngModel" name="SAME_ADDRESS" id="SAME_ADDRESS"
                                 (change)="sameAddressChange();" />
                          <div class="checkbox__data">
                            <div class="checkbox__indicator"></div>
                            <p class="checkbox__text">
                              Same as organization address
                            </p>
                          </div>
                        </label>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <small class="m-0 text-muted">Address</small>
                          <input type="text" RestrictFirstSpaceDirective class="input input__blue"
                                 #ADDRESS_1="ngModel" required maxlength="50" [(ngModel)]="checkoutDetails.ADDRESS_1"
                                 name="ADDRESS_1" id="ADDRESS_1">
                        </div>
                      </div>

                      <div class="col-md-5">
                        <div class="form-group">
                          <small class="m-0 text-muted">Zip</small>
                          <input type="text" numbersOnly class="input input__blue" #ADDRESS_ZIP="ngModel" required
                                 maxlength="5" #zipInput (keypress)="_keyPress($event)"
                                 [(ngModel)]="checkoutDetails.ADDRESS_ZIP" name="ADDRESS_ZIP" id="ADDRESS_ZIP">
                        </div>
                      </div>
                      <div class="col-md-7">
                        <div class="form-group">
                          <small class="m-0 text-muted">City</small>
                          <input type="text" appAlphabetWithSpaceOnly class="input input__blue"
                                 #ADDRESS_CITY="ngModel" required maxlength="30"
                                 [(ngModel)]="checkoutDetails.ADDRESS_CITY" name="ADDRESS_CITY" id="ADDRESS_CITY"
                                 disabled>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <small class="m-0 text-muted">State</small>
                          <input type="text" appAlphabetWithSpaceOnly class="input input__blue"
                                 #ADDRESS_STATE="ngModel" maxlength="30" [(ngModel)]="checkoutDetails.ADDRESS_STATE"
                                 name="ADDRESS_STATE" id="ADDRESS_STATE" disabled>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </form>

          <div class="row" *ngIf="(isPromoApplied && payableAmount == 0)">
            <div class="col-lg-8 col-md-12 free-rpt">
              <img src="../../../../../assets/images/free-report.svg" alt="Free Report">
              <div class="title">Free report</div>
              <div class="desc">
                No credit card details required. You have entered a promo code with a<br>
                100% discount. To get the report, click the "FREE Unlock" button.
              </div>
              <div class="row mt-3 justify-content-center">
                <div class="col-lg-6 col-md-12 w-100 px-3">
                  <button id="free-report-pay-click" type="button" class="button primary__button medium__button w-100"
                          (click)="payClick()" *ngIf="isPayVisible"
                          [disabled]="checkoutForm.invalid || isPayClicked || ((payableAmount > 0) && (!cardNumberValid || !cardDateValid || !cardCvvValid))">
                      Free Unlock
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
            <div class="row">
                <div class="col-md-12">
                    <div class="gray__box">
                        <div class="mb-2">
                            <small>Your choice & benefits</small>
                        </div>

                        <!-- Purchase Report -->
                        <ng-container *ngIf="constPricingPlanType.REPORT_PURCHASE == pricingPlanType">
                            <h4>Report purchase</h4>
                            <span class="color--blue font-weight-bold">
                                1 Report – ${{currencyPipe.transform(payableAmount || 0)}} total
                            </span>

                            <div class="row py-2 color--green">
                                <div class="col-md-12 py-1">
                                    <em class="fa fa-check"></em>
                                    Enter the company info, financials, risks
                                </div>
                                <div class="col-md-12 py-1">
                                    <em class="fa fa-check"></em>
                                    Detailed business valuation
                                </div>
                                <div class="col-md-12 py-1">
                                    <em class="fa fa-check"></em>
                                    All educational tips and information
                                </div>
                                <div class="col-md-12 py-1">
                                    <em class="fa fa-check"></em>
                                    Collaboration tools and reviews
                                </div>
                            </div>
                        </ng-container>

                        <!-- Professional Plan -->
                        <ng-container *ngIf="constPricingPlanType.PROFESSIONAL_PLAN == pricingPlanType">
                            <h4>Professional plan</h4>
                            <span class="color--blue font-weight-bold">
                                ${{currencyPipe.transform(payableAmount || 0)}} per year
                            </span>

                            <div class="row py-2 color--green">
                                <div class="col-md-12 py-1 d-flex">
                                    <em class="fa fa-check mr-1 pt-1"></em>
                                    Dynamic question based engine to provide quick approximate valuation
                                </div>
                                <div class="col-md-12 py-1 d-flex">
                                    <em class="fa fa-check mr-1 pt-1"></em>
                                    Dynamic question based engine with full and accurate business valuation
                                </div>
                                <div class="col-md-12 py-1">
                                    <em class="fa fa-check"></em>
                                    Detailed valuation PDF report
                                </div>
                                <div class="col-md-12 py-1">
                                    <em class="fa fa-check"></em>
                                    Save and edit report
                                </div>
                                <div class="col-md-12 py-1">
                                    <em class="fa fa-check"></em>
                                    Excel Import of Financials
                                </div>
                                <ng-container *ngIf="showMore">
                                    <div class="col-md-12 py-1">
                                        <em class="fa fa-check"></em>
                                        Unlimited versions of valuations
                                    </div>
                                    <div class="col-md-12 py-1">
                                        <em class="fa fa-check"></em>
                                        Report release manager
                                    </div>
                                    <div class="col-md-12 py-1">
                                        <em class="fa fa-check"></em>
                                        20 reports per month
                                    </div>
                                </ng-container>
                                <div role="button" class="m-2 font-weight-bold color--blue" (click)="showMore = !showMore">{{showMore ? 'Show less' : 'Show more'}}</div>
                            </div>
                        </ng-container>

                        <hr>
                        <div class="row font-weight-bold">
                            <div class="col-md-8 col-8">Promo code</div>
                            <div class="col-md-4 col-4 text-right">
                                <span class="color--blue" role="button" (click)="togglePromoCode()">
                                    {{!promoCodeAllowed ? 'Add' : 'Close'}}
                                </span>
                            </div>
                        </div>

                        <div class="row my-3" *ngIf="promoCodeAllowed">
                            <div class="col-md-12 my-2 color-secondary-gray">
                                Enter in this field a special promo code to receive a discount.
                                After entering the code, click the "Apply promo code" button.
                            </div>

                            <div class="col-md-12 my-2">
                                <input type="text" class="input input__large input__blue" placeholder="Enter promo code"
                                    [(ngModel)]="promoCode" id="txtPromoCode" #txtPromoCode="ngModel"
                                    name="txtPromoCode" [disabled]="isPromoApplied" autocomplete="off">
                            </div>

                            <div class="col-md-12 my-2" *ngIf="!isPromoApplied">
                                <button type="button" class="button secondary__button w-100 medium__button"
                                    (click)="applyPromoCode()">
                                    Apply promo code
                                </button>
                            </div>
                            <div class="col-md-12 my-2" *ngIf="isPromoApplied">
                                <button type="button" class="button red__button w-100 medium__button"
                                    (click)="removePromoCode()">
                                    Remove promo code
                                </button>
                            </div>
                        </div>
                        <hr>

                        <div class="row mt-3">
                            <div class="com-md-12 w-100 px-3">
                                <button id="checkout-pay-click" type="button"
                                    class="button primary__button medium__button w-100" (click)="payClick()"
                                    *ngIf="isPayVisible"
                                    [disabled]="checkoutForm.invalid || isPayClicked || ((payableAmount > 0) && (!cardNumberValid || !cardDateValid || !cardCvvValid))">
                                  @if(isPromoApplied && payableAmount == 0){
                                    Free Unlock
                                  }@else{
                                    Pay - ${{currencyPipe.transform(payableAmount || 0)}}
                                  }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
